import { Suspense, lazy } from 'react';
import { SORT_DAILY, SORT_MONTHLY, SORT_REALTIME } from './Utils';
import { getEnvs } from './environments';
const PowerGeneration = lazy(() =>
  import('../pages/power-generation/PowerGeneration'),
);
const Dashboard = lazy(() => import('../pages/Dashboard/Dashboard'));
const CommandControl = lazy(() =>
  import('../pages/command-control/CommandControl'),
);
const PlantInformation = lazy(() => import('../pages/PlantInformation'));
const AlarmEvent = lazy(() => import('../pages/alarm-event/AlarmEvent'));
const Monitoring = lazy(() => import('../pages/monitoring/Monitoring'));
const RealTime = lazy(() => import('../pages/realTime/RealTime'));
const Users = lazy(() => import('../pages/users/Users'));
const Logs = lazy(() => import('../pages/logs/Logs'));
const PlantAnalysis = lazy(() => import('../pages/plant-analysis/Page'));
const TrendPlot = lazy(() => import('../pages/trend-plot/Page'));
const KanbanBoard = lazy(() => import('../pages/kanbanBoard'));
const DemoPR = lazy(() => import('../pages/pr-reports/demo/DemoPR'));
const PRMain = lazy(() => import('../pages/pr-reports/PR'));
const DeviceManagement = lazy(() =>
  import('../pages/device-management/DeviceManagement'),
);
const Present = lazy(() => import('../pages/present/Present'));
const Diagram =
  getEnvs().REACT_APP_SCADA_FEATURE == 'true'
    ? lazy(() => import('../pages/scada/Scada'))
    : null;
const ScadaSialk =
  getEnvs().REACT_APP_SIALK_SCADA_FEATURE == 'true'
    ? lazy(() => import('../pages/scada/Sialk/SialkScada'))
    : null;

function PRLoader() {
  const envs = getEnvs() || {};
  const mode = String(envs.REACT_APP_MODE).trim().toLowerCase();
  console.log('PRLoader getEnvs():', JSON.stringify(envs));
  console.log('PRLoader mode(normalized):', mode);

  const isDemo = mode == 'demo';

  return (
    <Suspense>
      {isDemo ? <DemoPR /> : <PRMain />}
    </Suspense>
  );
}

export const PAGE_TITLE = 'Analysis';

export const EQUIPMENT_OPTION_INVERTER = {
  title: 'INVERTER',
  value: 'INVERTER',
};
export const PARAMETER_OPTION_INVERTER = null;
export const EQUIPMENT_OPTION_SORT = {
  title: 'Daily',
  value: SORT_REALTIME,
};
export const EQUIPMENT_OPTION_SORT_WEEKLY = {
  title: 'Weekly',
  value: SORT_DAILY,
};
export const EQUIPMENT_OPTION_SORT_MONTHLY = {
  title: 'Monthly',
  value: SORT_MONTHLY,
};
export const EQUIPMENT_OPTION_INTERVAL = { title: "15'", value: 15 };
export const EQUIPMENT_OPTION_METRIC = { title: 'AVG', value: 'AVG' };

export const KEY_EQUIPMENT_ID = 'equipmentId';
export const KEY_PARAMETER_ID = 'parameterId';
export const KEY_DEVICE_ID = 'deviceId';
export const KEY_SORT = 'sort';
export const KEY_INTERVAL = 'interval';
export const KEY_METRIC = 'metric';

export const KEY_USERS = 'Users';
export const KEY_LOGS = 'Logs';
export const KEY_DASHBOARD = 'Dashboard';
export const KEY_ALARMS = 'Alarms';
export const KEY_POWER_GENERATION = 'Power Generation';
export const KEY_DEVICES = 'Devices';
export const KEY_TRENDS = 'Trends';
export const KEY_ANALYSIS = 'Analysis';
export const KEY_INFORMATION = 'Information';
export const KEY_MONITORING = 'Monitoring';
export const KEY_REALTIME = 'Real Time';
export const KEY_PRESENT = 'Present';
export const KEY_COMMANDCONTROL = 'Command & Control';
export const KEY_RTU = 'RTUMonitoring';
export const KEY_SCADA = 'Scada';
export const KEY_PRREPORT = 'Performance';
export const KEY_KANBANBOARD = 'Task Management (O&M)';

const Screen_Resolution = window.innerWidth;

export const navbar = [
  {
    tag: <Dashboard />,
    name: KEY_DASHBOARD,
    href: '/',
    current: true,
    isNavbar: true,
  },
  {
    tag: <AlarmEvent />,
    name: KEY_ALARMS,
    href: '/alarm-event',
    current: false,
    isNavbar: true,
  },
  {
    tag: <PowerGeneration />,
    name: KEY_POWER_GENERATION,
    href: '/power-generation',
    current: false,
    isNavbar: true,
  },
  {
    tag: <DeviceManagement />,
    name: KEY_DEVICES,
    href: '/device-management',
    current: false,
    isNavbar: true,
  },
  {
    tag: <PlantAnalysis />,
    name: KEY_ANALYSIS,
    href: '/plant-analysis',
    current: false,
    isNavbar: true,
  },
  {
    tag: <RealTime />,
    name: KEY_REALTIME,
    href: '/real_time',
    current: false,
    isNavbar: true,
  },

  {
    tag: <TrendPlot />,
    name: KEY_TRENDS,
    href: '/trend-plot',
    current: false,
    isNavbar: true,
  },

  // ...(Diagram
  //   ? [
  //       {
  //         tag: <Diagram />,
  //         name: KEY_SCADA,
  //         href: '/scada',
  //         current: false,
  //         isNavbar: true,
  //       },
  //     ]
  //   : []),
  // ...(ScadaSialk
  //   ? [
  //       {
  //         tag: <ScadaSialk />,
  //         name: KEY_SCADA,
  //         href: '/scada-sialk',
  //         current: false,
  //         isNavbar: true,
  //       },
  //     ]
  //   : []),
  {
    tag: <PRLoader />,
    name: KEY_PRREPORT,
    href: '/Performance',
    current: false,
    isNavbar: true,
  },
  {
    tag: <Present />,
    name: KEY_PRESENT,
    href: '/present',
    current: false,
    isNavbar: true,
  },
  {
    tag: <CommandControl />,
    name: KEY_COMMANDCONTROL,
    href: '/command-control',
    current: false,
    isNavbar: true,
  },
  // {
  //   DEBT : this should be displayed only on production mode
  //   tag: <KanbanBoard />,
  //   name: KEY_KANBANBOARD,
  //   href: '/kanban-board',
  //   current: false,
  //   isNavbar: true,
  // },
  {
    tag: <PlantInformation />,
    name: KEY_INFORMATION,
    href: '/plant-information',
    current: false,
    isNavbar: false,
  },
  {
    tag: <Users />,
    name: KEY_USERS,
    href: '/users',
    current: false,
    isNavbar: false,
  },
  {
    tag: <Logs />,
    name: KEY_LOGS,
    href: '/logs',
    current: false,
    isNavbar: false,
  },

  // ...(window.location.host === '185.162.41.211:3000'
  //   ? [
  //       {
  //         tag: <RTUMonitoring />,
  //         name: KEY_RTU,
  //         href: '/rtumonitoring',
  //         current: false,
  //       },
  //     ]
  //   : []),  {

  // {
  //   tag: <Monitoring />,
  //   name: KEY_MONITORING,
  //   href: '/monitoring',
  //   current: false,
  // },
];

export const commonTooltipOptions = (options) => ({
  hideEmptySeries: false,
  x: {
    format: 'HH:mm yyyy-MM-dd',
  },
  y: {
    formatter: function (value, { seriesIndex, w }) {
      const seriesName = w.globals.seriesNames[seriesIndex];
      const option = options.find((opt) => opt.seriesName === seriesName);
      const unitName = option ? option.unitName : '';
      let unit = unitName.match(/\(([^)]+)\)/);

      // if (unit) {
      //   unit = unit[1];
      // } else {
      //   unit = unitName.includes('[')
      //     ? unitName.split('[')[1].split(']')[0]
      //     : unitName;
      // }
      return value == 0
        ? `0 `
        : value == null
        ? '-'
        : `${+value?.toFixed(2)}  `;
      // const defaultUnit = defaultUnits[seriesName];
      // return `${value} ${unit ? `(${unit})` : `(${defaultUnit})`}`;
    },
  },
});

export const MINCHARTSCALEPATAM = [
  'CT',
  'HM',
  'IRR',
  'LVTP',
  'PRE',
  'PTP',
  'TP',
  'WS',
];

export const INVERTER = 'INVERTER';
export const METER = 'METER';
export const WEATHER = 'WEATHER';
export const SENSOR = 'SENSOR';
export const RELAY = 'RELAY';
export const RTU = 'RTU';
export const STRING_MONITORING = 'STRING MONITORING';
export const RTU_PLC = 'RTU_PLC';
export const SWITCHING_DEVICE = 'SWITCHING_DEVICE';
export const TRANSFORMER = 'TRANSFORMER';
export const FarCOM = 'FarCOM';
export const Modbus = 'modbus';
export const DOFunctionCode = 5;
export const dataType = 'bit';
export const signalType = 'DO';
